import { handleError } from "@idss/notification";
import { Button, PinInput, Stack, Text } from "@mantine/core";
import { Form, useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { useMutation } from "@tanstack/react-query";

import { builder } from "@/builders";
import { LoginResponseData } from "@/builders/types/login";

interface TwoFaAuthProps {
  message: string;
  email: string;
  token: string;
  callback: (data: LoginResponseData) => void;
}

export function TwoFaAuth({ message, email, token, callback }: TwoFaAuthProps) {
  const form = useForm({
    initialValues: {
      token,
      email,
      otp: "",
    },
  });

  const { mutate, isPending } = useMutation({
    mutationFn: builder.$use.two_fa.verify,
    onError: handleError(),
    onSuccess: ({ data }) => {
      if (data) callback(data);
    },
  });

  function handleSubmit(values: typeof form.values) {
    mutate(values, {
      onSuccess: () => {
        modals.closeAll();
      },
    });
  }

  return (
    <Form form={form} onSubmit={handleSubmit}>
      <Stack gap={16}>
        <Text>{message}</Text>

        <PinInput
          w="100%"
          style={{
            flexWrap: "nowrap",
            justifyContent: "space-between",
          }}
          styles={{
            input: {
              fontSize: 32,
            },
          }}
          inputMode="numeric"
          aria-label="One time code"
          type="number"
          size="lg"
          {...form.getInputProps("otp")}
        />

        <Button loading={isPending} type="submit">
          Verify
        </Button>
      </Stack>
    </Form>
  );
}
